export default __webpack_public_path__ + "static/tb_helles_02-a718ffb987efcac5292298b81a2046f0.svg";